import { debounce } from 'throttle-debounce';

const $ = jQuery;

export function ajax_search() {
  $( document ).on( 'keyup', 'form.search-form', debounce( 250, async function ( this: HTMLFormElement, event ) {
    event.preventDefault();

    var s = this.s.value;

    if ( s.length >= 3 ) {

      var $content = $( '#content' );

      $content.addClass( 'loading' );

      try {

        const html = await wp.ajax.post( 'load_search_results', { s } ).promise();
        if ( !html ) throw new Error();

        $content.html( html.data );
        wc_initialise_results();

      } catch ( e ) {
        console.error( e );
      } finally {
        $content.removeClass( 'loading' );
      }
    }
  } ) );
}

export function wc_initialise_results() {
  // variations js
  if ( typeof window.wc_add_to_cart_variation_params !== 'undefined' ) {
    $( '.variations_form' ).each( function ( this: HTMLFormElement ) {
      $( this ).wc_variation_form();
    } );
  }
}
